import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { ErzeugungsanlagenTransformation } from '../model/erzeugungsanlagen-transformation';

@Pipe({
    name: 'nonEmptyLogFilter',
    standalone: false,
})
@Injectable()
export class NonEmptyLogPipe implements PipeTransform {
    transform(items: ErzeugungsanlagenTransformation[]): any[] {
        if (!items) {
            return [];
        }
        return items.filter(it => it.log.length > 0);
    }
}
